var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.683,
    height: 20.664,
    viewBox: "0 0 21.683 20.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Heart",
    "data-name": "Iconly/Light-Outline/Heart",
    transform: "translate(-1.727 -2.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heart",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M10.567,1.073A7.115,7.115,0,0,1,16.4.336c4.191,1.351,5.492,5.92,4.328,9.555-1.8,5.709-9.463,9.968-9.789,10.147a.773.773,0,0,1-.742,0C9.876,19.863,2.264,15.667.409,9.892a0,0,0,0,1,0,0C-.757,6.255.54,1.685,4.726.336A6.947,6.947,0,0,1,10.567,1.073ZM5.2,1.81C1.814,2.9.963,6.546,1.883,9.419c1.447,4.5,7.166,8.145,8.686,9.046,1.525-.911,7.285-4.592,8.686-9.042.92-2.876.066-6.52-3.327-7.613a5.46,5.46,0,0,0-4.884.818.774.774,0,0,1-.94.006A5.4,5.4,0,0,0,5.2,1.81Z",
    transform: "translate(0 0)",
    fill: "#fe2e1c",
    stroke: "#fe2e1c",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.8020bdbcd4ecb45c3532d93ac7c7e0c7.svg";
export { ForwardRef as ReactComponent };